import type { MembershipRole } from "@fleetminder/contracts";

export const roleLabels: Record<MembershipRole, string> = {
  member: "Manager",
  admin: "Admin",
  owner: "Owner",
};

/**
 * One line per role for whoever picks it. These follow the API's rules: only
 * an owner changes roles or removes an owner or admin, and a manager cannot
 * invite anyone or change company settings.
 */
export const roleDescriptions: Record<MembershipRole, string> = {
  member:
    "Day-to-day work on vehicles, drivers, maintenance and service. Can't invite people or change company settings.",
  admin: "Everything except changing roles or removing owners and admins.",
  owner: "Everything, including changing roles and removing anyone.",
};

export function roleLabel(role: MembershipRole): string {
  return roleLabels[role];
}
